import type { MessageInstance } from 'antd/es/message/interface';
import type { ModalStaticFunctions } from 'antd/es/modal/confirm';
import type { NotificationInstance } from 'antd/es/notification/interface';

// 全局 antd 静态方法代理，由 AntdAppHelper 组件注入
let message: MessageInstance;
let modal: Omit<ModalStaticFunctions, 'warn'>;
let notification: NotificationInstance;

export function setAntdGlobal(
  msg: MessageInstance,
  mdl: Omit<ModalStaticFunctions, 'warn'>,
  ntf: NotificationInstance,
) {
  message = msg;
  modal = mdl;
  notification = ntf;
}

// 代理对象，确保调用时已注入
export const antdMessage = new Proxy({} as MessageInstance, {
  get(_, prop) {
    return message?.[prop as keyof MessageInstance];
  },
});

export const antdModal = new Proxy({} as Omit<ModalStaticFunctions, 'warn'>, {
  get(_, prop) {
    return modal?.[prop as keyof typeof modal];
  },
});

export const antdNotification = new Proxy({} as NotificationInstance, {
  get(_, prop) {
    return notification?.[prop as keyof NotificationInstance];
  },
});
